module.exports = __webpack_public_path__ + "img/icon-table-black.daac7590.svg";